import './contactUs.css'

const ContactUs = () => {
  return (
    <section id="contact">
      <div className="container">
        <div className="contact-container">
          <h1>تواصل معنا</h1>
          <div className="contact-content">
            <div className="icons-container">
              <a
                href="https://wa.me/+966582779315"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-link"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                  alt="WhatsApp"
                  className="icon"
                />
                <span>تواصل عبر الواتساب</span>
              </a>
              <a href="mailto:info@ruaalafaq.com" className="icon-link">
                <img
                  src="https://thumb.ac-illust.com/9e/9e161945c411e58e7dcd6b7e8ef4b352_t.jpeg"
                  alt="Email"
                  className="icon"
                />
                <span>تواصل عبر الإيميل</span>
              </a>
            </div>
            <div className="map-container">
              <h2>موقعنا</h2>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m8!1m3!1d215.05167432593038!2d46.84534462392536!3d24.865956098032473!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d24.86593419606105!2d46.84533724785071!5e1!3m2!1sar!2seg!4v1735223758868!5m2!1sar!2seg"
                title="Our Location"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactUs
